import * as React from "react";

import { equals, pick } from "ramda";

export default function useConnectedListHistory<Item extends {id: number}>(listKey: string, connectedList: ConnectedList<Item>) {
  React.useEffect(() => {
    const historyObject: Partial<ListState<Item>> = currentConnectedListHistory(listKey);
    connectedList.setListHistoryKeyValues(historyObject);
  }, []);

  React.useEffect(() => {
    const currentListState = currentConnectedListHistory(listKey);
    const futureListState = pick(LIST_HISTORY_KEYS, connectedList);

    if (!equals(currentListState, futureListState)) {
      const currentState = history.state;
      const newState = {...currentState, [listKey]: futureListState};
      history.replaceState(newState, document.title);
    }
  }, [connectedList]);
}

function currentConnectedListHistory(listKey: string) {
  return (history.state || {})[listKey] || {};
}

const LIST_HISTORY_KEYS = [
  "search",
  "sort_by",
  "sort_order",
  "per_page",
  "activeFilters",
] as const;
